import httpService from "./httpService";
import config from '../config/apiConfig';


export const getDatosNegocio = async() => {
    try {
   
        
        // 2. Obtenemos el token desde el localStorage
        const token = localStorage.getItem("token");

        const url = config.api_url + '/negocio/';
        // 3. Enviamos el token en los headers
        // Nota: La mayoría de las veces httpService (si es Axios) recibe los headers como segundo parámetro
        const response = await httpService.get(url, {
            headers: {
                'token': token  // Aquí enviamos el token
            }
        });
        console.log('resp negocio datos', response);
        return response.data.datos;
    }
    catch(error) {
        console.error("Error al desplegar los datos del negocio:", error);
        // Como pediste antes, si prefieres no usar toast:
        // alert("Se ha provocado un error al desplegar los datos de su negocio!");
    }
}

export const getPDF = async (
  terminal,
) => {
  try {
    const response = await httpService.get('localhost:4002/prueba');
    console.log("Prueba de impresion", response)
    return response;
  } catch (error) {
    console.log('error abre planilla lokgo',error);
    return {};
  }
};